import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import TopicClickSuggestion from "./click-suggestion-topic";
import Link from "@default/general-components/link/link";

const ClickSuggestionsTopics = ({ content }) => {
  const sectionClassNames = classNames({
    "paragraph paragraph-click-suggestions-topics": true,
  });

  return (
    <section className={sectionClassNames}>
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-11 offset-lg-1 links">
            <ul className="ctas">
              {content.fieldTopicsClickSuggestions &&
                content.fieldTopicsClickSuggestions.map(
                  (linkContent, index) => (
                    <li key={index}>
                      <Link
                        link={linkContent?.fieldLink}
                        aria-label={`Link: ${linkContent?.fieldLink?.title}`}>
                        <TopicClickSuggestion content={linkContent} />
                      </Link>
                    </li>
                  )
                )}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

ClickSuggestionsTopics.propTypes = {
  viewMode: PropTypes.string,
  content: PropTypes.shape({
    fieldTopicsClickSuggestions: PropTypes.arrayOf(
      PropTypes.shape({
        fieldImage: PropTypes.object,
        fieldLink: PropTypes.shape({
          title: PropTypes.string,
          uri: PropTypes.shape({
            routed: PropTypes.bool,
            path: PropTypes.string,
          }),
        }),
      })
    ),
  }),
};

export default ClickSuggestionsTopics;
